import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, BasicTooltip, ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Button, Chip, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { track, events } from 'src/configs/amplitude';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ActiveBuildingMenu } from 'src/components/property/ActiveBuildingMenu';
import { InactiveBuildingMenu } from 'src/components/property/InactiveBuildingMenu';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import { useStore } from 'src/stores';
import { dateToFormat, monthNames } from 'src/utils/date';
// import TableInformationModal from './TableInformationModal';
import useStyles from './styles';
export const BuildingsTable = observer(_ref => {
  let showDemo = _ref.showDemo;
  const classes = useStyles();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const page = 'Dashboard Page';
  const goToTenancies = id => {
    navigate("/residencies?id=".concat(id, "&tab=residencies"));
  };
  const _useState = useState(10),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  const enrollResidentIconTrigger = /*#__PURE__*/React.createElement(BasicTooltip, {
    title: "Enroll resident",
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => track(events.modalOpened('Enroll Resident'), {
      page
    }),
    'custom-attribute': '92-buildings-table'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  })));
  const getTooltipSuccess = date => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), /*#__PURE__*/React.createElement("span", null, t('dashboard_page.launched_on'), " ", date));
  const getTooltipInfo = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", null, t('dashboard_page.property_is_not_ready')));
  const getTooltipWarning = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    type: "clock"
  }), /*#__PURE__*/React.createElement("span", null, "Some warning message"));
  const getTooltipInactive = date => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    type: "building-minus"
  }), /*#__PURE__*/React.createElement("span", null, t('dashboard_page.deactivated_on'), " ", date));
  const getTooltipDemo = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    pattern: "white",
    type: "livable-square"
  }), /*#__PURE__*/React.createElement("span", null, t('dashboard_page.not_a_property')));
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const getValue = (param, sign) => {
    switch (sign) {
      case 'percent':
        return "%".concat(Number(param).toFixed(2));
      case 'dollar':
        return "$".concat(Number(param).toFixed(2));
      default:
        return param;
    }
  };
  const renderCell = (param, sign) => {
    const isNull = param === null;
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(isNull ? classes.noData : '', " cellContent")
    }, isNull ? 'N/A' : getValue(param, sign));
  };
  const renderHeader = (text, month) => /*#__PURE__*/React.createElement("span", {
    className: classes.rightAlign
  }, t(text, _objectSpread({}, month)), indicators);
  const columns = [{
    field: 'enrollmentDate',
    width: 410,
    flex: 1,
    minWidth: 410,
    maxWidth: store.company.companyFeatureStore.isAppfolio ? 1200 : 410,
    align: 'right',
    renderHeader: () => /*#__PURE__*/React.createElement("span", null, t('dashboard_page.property'), indicators),
    valueGetter: value => {
      var _value$row;
      return value === null || value === void 0 || (_value$row = value.row) === null || _value$row === void 0 ? void 0 : _value$row.propertyAddress;
    },
    sortComparator: (v1, v2) => {
      var _ref2;
      return (_ref2 = '' + v1) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(v2, undefined, {
        numeric: true
      });
    },
    renderCell: params => /*#__PURE__*/React.createElement("div", {
      className: classes.statusInfo
    }, params.row.isDemo && /*#__PURE__*/React.createElement(ExpandedTooltip, {
      title: getTooltipDemo(),
      type: "success",
      placement: "top"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.enrollmentDateWrapper
    }, /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      pattern: "gradient",
      type: "livable-inner"
    }), params.row.enrollmentDate && /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.enrollmentDate,
      color: "light"
    }, t('dashboard_page.demo')))), params.row.propertyStatus === PROPERTY_STATUS_ENUM.Deactivated && !params.row.isDemo && /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: getTooltipInactive(dateToFormat(params.row.enrollmentDate)),
      type: "default"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.enrollmentDateWrapper
    }, /*#__PURE__*/React.createElement(Chip, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "building-minus"
      }),
      variant: "inactiveIcon"
    }), params.row.enrollmentDate && /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.enrollmentDate,
      color: "light"
    }, dateToFormat(params.row.enrollmentDate)))), params.row.propertyStatus === PROPERTY_STATUS_ENUM.Deactivated && !params.row.isDemo && /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: getTooltipWarning(),
      type: "warning"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.enrollmentDateWrapper
    }, /*#__PURE__*/React.createElement(Chip, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "clock"
      }),
      variant: "warningIcon"
    }), params.row.enrollmentDate && /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.enrollmentDate,
      color: "light"
    }, dateToFormat(params.row.enrollmentDate)))), params.row.propertyStatus === PROPERTY_STATUS_ENUM.Active && !params.row.isDemo && /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "success",
      title: getTooltipSuccess(dateToFormat(params.row.enrollmentDate)),
      placement: "top"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.enrollmentDateWrapper
    }, /*#__PURE__*/React.createElement(Chip, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "building"
      }),
      variant: "successIcon"
    }), params.row.enrollmentDate && /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.enrollmentDate,
      color: "light"
    }, dateToFormat(params.row.enrollmentDate)))), params.row.propertyStatus === PROPERTY_STATUS_ENUM.Inactive && !params.row.isDemo && /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: getTooltipInfo(),
      type: "info"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.enrollmentDateWrapper
    }, /*#__PURE__*/React.createElement(Chip, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "edit"
      }),
      variant: "infoIcon"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.enrollmentDate,
      color: "light"
    }, t('dashboard_page.incomplete')))), params.row.propertyStatus === PROPERTY_STATUS_ENUM.Deleted && !params.row.isDemo && /*#__PURE__*/React.createElement(Chip, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "clock"
      }),
      variant: "criticalIcon"
    }), /*#__PURE__*/React.createElement(BasicTooltip, {
      title: params.row.propertyAddress,
      placement: "top",
      hideOnMobile: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: "".concat(classes.propertyAddress, " ").concat(store.company.companyFeatureStore.isAppfolio ? 'fullWidth' : '')
    }, params.row.propertyAddress)))
  }, {
    field: 'unitsTotal',
    headerAlign: 'right',
    align: 'right',
    width: 140,
    renderHeader: () => /*#__PURE__*/React.createElement("span", {
      className: classes.rightAlign
    }, t('dashboard_page.units_enrolled_cell'), indicators),
    renderCell: params => /*#__PURE__*/React.createElement(React.Fragment, null, params.row.unitsTotal > 0 && /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " cellContent")
    }, params.row.unitsEnrolled, "/", params.row.unitsTotal), params.row.unitsTotal === 0 && /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(classes.noData, " cellContent")
    }, "0/0"))
  },
  // {
  //   field: 'totalUtilityCostToDate',
  //   headerAlign: 'right',
  //   align: 'right',
  //   width: 109,
  //   renderHeader: () => (
  //     <span className={classes.rightAlign}>
  //       {t('dashboard_page.total_utility_cost_cell')}
  //       {indicators}
  //     </span>
  //   ),
  //   renderCell: params => (
  //     <>
  //       {params.row.totalUtilityCostToDate > 0 && (
  //         <span className={`${classes.cellContent} cellContent`}>
  //           ${params.row.totalUtilityCostToDate}
  //         </span>
  //       )}
  //       {params.row.totalUtilityCostToDate === 0 && (
  //         <span
  //           className={`${classes.cellContent} ${classes.noData} cellContent`}
  //         >
  //           N/A
  //         </span>
  //       )}
  //     </>
  //   ),
  // },
  // {
  //   field: 'utilityCostRecoveryToDate',
  //   headerAlign: 'right',
  //   align: 'right',
  //   width: 110,
  //   renderHeader: () => (
  //     <span className={classes.rightAlign}>
  //       {t('dashboard_page.utility_cost_cell')}
  //       {indicators}
  //     </span>
  //   ),
  //   renderCell: params => (
  //     <>
  //       {params.row.utilityCostRecoveryToDate > 0 && (
  //         <span className={`${classes.cellContent} cellContent`}>
  //           ${params.row.utilityCostRecoveryToDate}
  //         </span>
  //       )}
  //       {params.row.utilityCostRecoveryToDate === 0 && (
  //         <span
  //           className={`${classes.cellContent} ${classes.noData} cellContent`}
  //         >
  //           N/A
  //         </span>
  //       )}
  //     </>
  //   ),
  // },
  // {
  //   field: 'utilityCostRecoveryPriorMonth',
  //   headerAlign: 'right',
  //   align: 'right',
  //   width: 127,
  //   renderHeader: () => (
  //     <span className={classes.rightAlign}>
  //       {t('dashboard_page.utility_cost_recovery_cell')}
  //       {indicators}
  //     </span>
  //   ),
  //   renderCell: params => (
  //     <>
  //       {params.row.utilityCostRecoveryPriorMonth > 0 && (
  //         <span className={`${classes.cellContent} cellContent`}>
  //           ${params.row.utilityCostRecoveryPriorMonth}
  //         </span>
  //       )}
  //       {params.row.utilityCostRecoveryPriorMonth === 0 && (
  //         <span
  //           className={`${classes.cellContent} ${classes.noData} cellContent`}
  //         >
  //           N/A
  //         </span>
  //       )}
  //     </>
  //   ),
  // },
  // {
  //   field: 'recoveryPercentage',
  //   headerAlign: 'right',
  //   align: 'right',
  //   width: 115,
  //   renderHeader: () => (
  //     <span className={classes.rightAlign}>
  //       <span>{t('dashboard_page.recovery_cell')}</span>
  //       {indicators}
  //     </span>
  //   ),
  //   renderCell: params => (
  //     <>
  //       {params.row.recoveryPercentage > 0 && (
  //         <span className={`${classes.cellContent} cellContent`}>
  //           {params.row.recoveryPercentage}%
  //         </span>
  //       )}
  //       {params.row.recoveryPercentage === 0 && (
  //         <span
  //           className={`${classes.cellContent} ${classes.noData} cellContent`}
  //         >
  //           N/A
  //         </span>
  //       )}
  //     </>
  //   ),
  // },
  {
    align: 'right',
    field: 'accountsReceivable',
    headerAlign: 'right',
    renderCell: params => renderCell(params.row.accountsReceivable, 'dollar'),
    renderHeader: () => renderHeader('dashboard_page.accounts_receivable_cell'),
    width: 140
  }, {
    align: 'right',
    field: 'distributionForCurrentMonth',
    headerAlign: 'right',
    renderCell: params => renderCell(params.row.distributionForCurrentMonth, 'dollar'),
    renderHeader: () => {
      var _store$properties$fir;
      return renderHeader('residencies_page.distribution_for', {
        month: monthNames[((_store$properties$fir = store.properties.first) === null || _store$properties$fir === void 0 ? void 0 : _store$properties$fir.previousMonth) - 1]
      });
    },
    width: 140
  }, {
    align: 'right',
    field: 'distributionToDate',
    headerAlign: 'right',
    renderCell: params => renderCell(params.row.distributionToDate, 'dollar'),
    renderHeader: () => renderHeader('residencies_page.distribution_to_date'),
    width: 140
  }, {
    align: 'right',
    field: 'distributionForNextMonth',
    headerAlign: 'right',
    renderCell: params => renderCell(params.row.distributionForNextMonth, 'dollar'),
    renderHeader: () => {
      var _store$properties$fir2;
      return renderHeader('residencies_page.estimated_distribution', {
        month: monthNames[((_store$properties$fir2 = store.properties.first) === null || _store$properties$fir2 === void 0 ? void 0 : _store$properties$fir2.nextMonth) - 1]
      });
    },
    width: 140
  }, {
    field: 'actions',
    width: 170,
    headerAlign: 'right',
    align: 'right',
    filterable: false,
    sortable: false,
    hideable: false,
    renderHeader: () => /*#__PURE__*/React.createElement("div", {
      className: classes.toolboxWrapperHeader
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.rightAlign
    }, t('dashboard_page.action_toolbox_cell'))),
    renderCell: params => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.actions
    }, params.row.propertyStatus !== PROPERTY_STATUS_ENUM.Inactive && /*#__PURE__*/React.createElement(React.Fragment, null, !store.company.companyFeatureStore.disableEnrollResident ? /*#__PURE__*/React.createElement(EnrollmentModal, {
      page: 'Dashboard Page',
      propertyId: params.row.propertyId,
      trigger: enrollResidentIconTrigger
    }) : null, /*#__PURE__*/React.createElement(ActiveBuildingMenu, {
      id: params.row.propertyId
    })), params.row.propertyStatus === PROPERTY_STATUS_ENUM.Inactive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: t('dashboard_page.continue_adding_details'),
      placement: "top",
      hideOnMobile: true
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      onClick: () => navigate("/new_property?not_completed_id=".concat(params.row.propertyId)),
      'custom-attribute': '93-buildings-table'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }))), /*#__PURE__*/React.createElement(InactiveBuildingMenu, {
      id: params.row.propertyId
    }))))
  }];
  if (store.company.companyFeatureStore.isAppfolio) columns.splice(2, 4);
  const handleCellClick = params => {
    if (params.field === 'actions') return;
    if (params.row.propertyStatus === PROPERTY_STATUS_ENUM.Inactive) {
      navigate("/new_property?not_completed_id=".concat(params.row.propertyId));
    } else {
      goToTenancies(params.row.propertyId);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-tut": "reactour__demo",
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(DataGrid, {
    getRowId: row => row.propertyId,
    onCellClick: handleCellClick,
    rows: toJS(store.properties.allPropertyList),
    columns: columns,
    pageSize: pageSize,
    rowsPerPageOptions: [5, 10, 20],
    onPageSizeChange: newPageSize => setPageSize(newPageSize),
    pagination: true,
    disableRowSelectionOnClick: true,
    autoHeight: true,
    columnHeaderHeight: 95,
    rowHeight: 77,
    hideFooterSelectedRowCount: true,
    getRowClassName: () => classes.row,
    slots: {
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton"
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      }))
    },
    initialState: {
      sorting: {
        sortModel: [{
          field: 'enrollmentDate',
          sort: 'asc'
        }]
      }
    },
    localeText: {
      noRowsLabel: t('dashboard_page.add_first_property')
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    }
  }), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.properties.deletePropertyAsync.inProgress
  })), showDemo && /*#__PURE__*/React.createElement("div", {
    className: classes.demoBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('dashboard_page.check_our_demo_property')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('dashboard_page.demo_property_text'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small"
  }, t('buttons.got_it')))));
});
BuildingsTable.propTypes = {
  buildingsData: PropTypes.arrayOf(PropTypes.shape({
    accountsReceivable: PropTypes.number,
    enrollmentDate: PropTypes.string,
    propertyAddress: PropTypes.string,
    propertyId: PropTypes.string,
    propertyStatus: PropTypes.string,
    recoveryPercentage: PropTypes.number,
    totalUtilityCostToDate: PropTypes.number,
    unitsEnrolled: PropTypes.number,
    unitsTotal: PropTypes.number,
    utilityCostRecoveryPriorMonth: PropTypes.number,
    utilityCostRecoveryToDate: PropTypes.number
  }))
};